var map = {
	"./temp1.vue": "Z0wN",
	"./temp2.vue": "WT/F",
	"./temp3.vue": "U8/C"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "LlyG";


//////////////////
// WEBPACK FOOTER
// ./src/components/main-content/router-test nonrecursive temp\d\.(vue)$
// module id = LlyG
// module chunks = 64